import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Sparkles } from "lucide-react";

/** Mobile slide-out menu. Renders only when `open` is true. */
export default function MobileMenu({ open, groups, user, logout, nav, onClose }) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div className="lg:hidden border-t border-border/60 bg-background/95 backdrop-blur-xl">
      <div className="container-x flex flex-col gap-3 py-4">
        {groups.map((g) => (
          <div key={g.id}>
            <p className="eyebrow mb-2 px-3">{g.label}</p>
            <div className="flex flex-col">
              {g.items.map(([to, label]) => (
                <NavLink
                  key={to}
                  to={to}
                  onClick={onClose}
                  className={({ isActive }) =>
                    `rounded-xl px-3 py-2 text-sm ${isActive ? "bg-secondary text-foreground" : "text-muted-foreground"}`
                  }
                >
                  {label}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
        <div className="mt-2 flex gap-2">
          {user ? (
            <button
              onClick={async () => { await logout(); onClose(); nav("/"); }}
              className="btn-secondary flex-1"
            >
              {t("nav.logout")}
            </button>
          ) : (
            <>
              <Link to="/login" onClick={onClose} className="btn-secondary flex-1">
                {t("nav.sign_in")}
              </Link>
              <Link to="/contact" onClick={onClose} className="btn-primary flex-1">
                {t("nav.join")}
              </Link>
            </>
          )}
        </div>
        <Link
          to="/ai-tools/waste-to-resource"
          onClick={onClose}
          className="mt-2 flex items-center justify-center gap-2 rounded-full border border-signal-lime/40 px-4 py-2 text-xs text-signal-lime"
        >
          <Sparkles size={14} /> {t("home.cta_engine")}
        </Link>
      </div>
    </div>
  );
}
